module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.chartData && _vm.height) ? _c('div', {
    attrs: {
      "id": 'lineWrapper' + _vm.facetId
    }
  }, [(_vm.site && _vm.height > 0) ? _c('h4', {
    staticClass: "subtitle",
    staticStyle: {
      "margin-bottom": "0"
    }
  }, [_vm._v(_vm._s(_vm.site))]) : _vm._e(), _vm._v(" "), (_vm.height > 0) ? _c('svg', {
    attrs: {
      "id": 'line' + _vm.facetId,
      "width": _vm.chartWidth,
      "height": _vm.height
    }
  }) : _vm._e()]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a819c324","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/LineChart.vue
// module id = 608
// module chunks = 0